import PersianMessages from "ra-language-farsi";

const fa = {
  ...PersianMessages,
  synapseadmin: {
    auth: {
      base_url: "آدرس سرور",
      welcome: "به پنل مدیریت هیوا خوش‌آمدید",
      server_version: "نسخه سرور",
      username_error: "Please enter fully qualified user ID: '@user:domain'",
      protocol_error: "URL has to start with 'http://' or 'https://'",
      url_error: "url وارد شده معتبر نمی‌باشد",
    },
    users: {
      invalid_user_id:
          "Must be a fully qualified Matrix user-id, e.g. @user_id:homeserver",
    },
    rooms: {
      tabs: {
        basic: "اطلاع کلی",
        members: "اعضا",
        detail: "جزئیات",
        permission: "دسترسی‌ها",
      },
    },
    reports: { tabs: { basic: "کلیات", detail: "جزئیات" } },
  },
  import_users: {
    error: {
      at_entry: "At entry %{entry}: %{message}",
      error: "Error",
      required_field: "Required field '%{field}' is not present",
      invalid_value:
        "Invalid value on line %{row}. '%{field}' field may only be 'true' or 'false'",
      unreasonably_big:
        "Refused to load unreasonably big file of %{size} megabytes",
      already_in_progress: "An import run is already in progress",
      id_exits: "ID %{id} already present",
    },
    title: "Import users via CSV",
    goToPdf: "Go to PDF",
    cards: {
      importstats: {
        header: "Import users",
        users_total:
          "%{smart_count} user in CSV file |||| %{smart_count} users in CSV file",
        guest_count: "%{smart_count} guest |||| %{smart_count} guests",
        admin_count: "%{smart_count} admin |||| %{smart_count} admins",
      },
      conflicts: {
        header: "Conflict strategy",
        mode: {
          stop: "Stop on conflict",
          skip: "Show error and skip on conflict",
        },
      },
      ids: {
        header: "IDs",
        all_ids_present: "IDs present on every entry",
        count_ids_present:
          "%{smart_count} entry with ID |||| %{smart_count} entries with IDs",
        mode: {
          ignore: "Ignore IDs in CSV and create new ones",
          update: "Update existing records",
        },
      },
      passwords: {
        header: "Passwords",
        all_passwords_present: "Passwords present on every entry",
        count_passwords_present:
          "%{smart_count} entry with password |||| %{smart_count} entries with passwords",
        use_passwords: "Use passwords from CSV",
      },
      upload: {
        header: "Input CSV file",
        explanation:
          "Here you can upload a file with comma separated values that is processed to create or update users. The file must include the fields 'id' and 'displayname'. You can download and adapt an example file here: ",
      },
      startImport: {
        simulate_only: "Simulate only",
        run_import: "Import",
      },
      results: {
        header: "Import results",
        total:
          "%{smart_count} entry in total |||| %{smart_count} entries in total",
        successful: "%{smart_count} entries successfully imported",
        skipped: "%{smart_count} entries skipped",
        download_skipped: "Download skipped records",
        with_error:
          "%{smart_count} entry with errors ||| %{smart_count} entries with errors",
        simulated_only: "Run was only simulated",
      },
    },
  },
  resources: {
    users: {
      backtolist: "بازگشت به لیست",
      name: "کاربر |||| کاربران",
      email: "ایمیل",
      msisdn: "تلفن همراه",
      threepid: "ایمیل / تلفن همراه",
      fields: {
        avatar: "آواتار",
        id: "شناسه کاربر",
        name: "نام",
        is_guest: "مهمان",
        admin: "ادمین",
        deactivated: "غیر‌فعال",
        guests: "نمایش کاربران مهمان",
        show_deactivated: "نمایش کاربران غیرفعال شده",
        user_id: "جستجوی کاربر",
        displayname: "نام نمایش داده شده",
        password: "گذرواژه",
        avatar_url: "url آواتار",
        avatar_src: "آواتار",
        medium: "نوع شناسه",
        threepids: "شناسه سوم‌شخص",
        address: "آدرس",
        creation_ts_ms: "زمان ایجاد",
        consent_version: "نسخه تفاهم",
      },
      helper: {
        deactivate: "در صورتی که کاربر غیرفعال شود، امکان فعال کردن مجدد وجود ندارد",
        erase: "Mark the user as GDPR-erased",
      },
      action: {
        erase: "پاک کردن داده‌های کاربر",
      },
    },
    rooms: {
      name: "گروه |||| گروه‌ها",
      fields: {
        room_id: "شناسه گروه",
        name: "نام",
        canonical_alias: "نام مستعار",
        joined_members: "اعضا",
        joined_local_members: "اعضای محلی",
        joined_local_devices: "دستگاه‌های محلی",
        state_events: "رویداد‌های وضعیت",
        version: "نسخه",
        is_encrypted: "رمزشده",
        encryption: "رمزنگاری",
        federatable: "قابل انتشار در دیگر سرور‌ها",
        public: "عمومی",
        creator: "سازنده",
        join_rules: "قوانین پیوستن",
        guest_access: "دسترسی مهمان",
        history_visibility: "نمایان بودن تاریخچه",
        topic: "موضوع",
        avatar: "آواتار",
      },
      helper: {
        forward_extremities:
          "Forward extremities are the leaf events at the end of a Directed acyclic graph (DAG) in a room, aka events that have no children. The more exist in a room, the more state resolution that Hivaa needs to perform (hint: it's an expensive operation). While Hivaa has code to prevent too many of these existing at one time in a room, bugs can sometimes make them crop up again. If a room has >10 forward extremities, it's worth checking which room is the culprit and potentially removing them using the SQL queries mentioned in #1760.",
      },
      enums: {
        join_rules: {
          public: "عمومی",
          knock: "درخواست",
          invite: "دعوت",
          private: "خصوصی",
        },
        guest_access: {
          can_join: "مهمان‌ها می‌توانند عضو شوند",
          forbidden: "مهمان‌ها نمی‌توانند عضو شوند",
        },
        history_visibility: {
          invited: "از زمان دعوت",
          joined: "از زمان پیوستن",
          shared: "از زمان به اشتراک‌گذاری",
          world_readable: "هرکس",
        },
        unencrypted: "رمزگذاری نشده",
      },
      erase: {
        title: "حذف اتاق",
        content:
          "Are you sure you want to delete the room? This cannot be undone. All messages and shared media in the room will be deleted from the server!",
      },
    },
    reports: {
      name: "رخدا‌د گزارش شده |||| رخداد‌های گزارش شده",
      fields: {
        id: "شناسه",
        received_ts: "زمان گزارش",
        user_id: "گزارش دهنده",
        name: "نام اتاق",
        score: "امتیاز",
        reason: "علت",
        event_id: "شناسه رویداد",
        event_json: {
          origin: "سرور حاوی پیام",
          origin_server_ts: "زمان ارسال",
          type: "نوع رویداد",
          content: {
            msgtype: "نوع محتوا",
            body: "محتوا",
            format: "فرمت",
            formatted_body: "محتوای فرمت شده",
            algorithm: "الگوریتم",
          },
        },
      },
    },
    connections: {
      name: "اتصالات",
      fields: {
        last_seen: "تاریخ",
        ip: "IP آدرس",
        user_agent: "عامل کاربر",
      },
    },
    devices: {
      name: "دستگاه |||| دستگاه‌ها",
      fields: {
        device_id: "شناسه دستگاه",
        display_name: "نام دستگاه",
        last_seen_ts: "مهر زمان",
        last_seen_ip: "IP آدرس",
      },
      action: {
        erase: {
          title: "حذف %{id}",
          content: 'Are you sure you want to remove the device "%{name}"?',
          success: "دستگاه با موفقیت حذف شد",
          failure: "خطایی پیش‌آمد",
        },
      },
    },
    users_media: {
      name: "مدیا",
      fields: {
        media_id: "شناسه مدیا",
        media_length: "حجم فایل (بایت)",
        media_type: "نوع",
        upload_name: "نام فایل",
        quarantined_by: "قرنطینه شده توسط",
        safe_from_quarantine: "ایمن از قرنطینه",
        created_ts: "تاریخ ایجاد",
        last_access_ts: "آخرین دسترسی",
      },
    },
    delete_media: {
      name: "مدیا",
      fields: {
        before_ts: "آخرین دسترسی قبل از",
        size_gt: "حجیم تر از (به بایت)",
        keep_profiles: "تصاویر پروفایل را نگه‌دار",
      },
      action: {
        send: "پاک کردن مدیا",
        send_success: "درخواست با موفقیت ارسال شد.",
        send_failure: "خطایی رخ داد.",
      },
      helper: {
        send:
          "This API deletes the local media from the disk of your own server. This includes any local thumbnails and copies of media downloaded. This API will not affect media that has been uploaded to external media repositories.",
      },
    },
    pushers: {
      name: "اعلان‌دهنده |||| اعلان‌دهندگان",
      fields: {
        app: "برنامه",
        app_display_name: "نام نمایشی برنامه",
        app_id: "شناسه برنامه",
        device_display_name: "نام نمایشی دستگاه",
        kind: "نوع",
        lang: "زبان",
        profile_tag: "تگ پروفایل",
        pushkey: "کلید اعلان‌دهنده",
        data: { url: "URL" },
      },
    },
    servernotices: {
      name: "Server Notices",
      send: "ارسال پیام سیستمی",
      fields: {
        body: "Message",
      },
      action: {
        send: "ارسال",
        send_success: "پیام با موفقیت ارسال شد",
        send_failure: "خطایی رخ داد.",
      },
      helper: {
        send:
          'Sends a server notice to the selected users. The feature "Server Notices" has to be activated at the server.',
      },
    },
    user_media_statistics: {
      name: "مدیای کاربران",
      fields: {
        media_count: "تعداد مدیا",
        media_length: "طول مدیا",
      },
    },
    forward_extremities: {
      name: "رخداد‌های غیرمتعارف",
      fields: {
        id: "شناسه رخداد",
        received_ts: "مهر زمان",
        depth: "عمق",
        state_group: "وضعیت گروه",
      },
    },
        room_state: {
      name: "رویداد‌های وضعیت",
      fields: {
        type: "نوع",
        content: "محتوا",
        origin_server_ts: "زمان ارسال",
        sender: "ارسال‌کننده",
      },
    },
    room_directory: {
      name: "فهرست اتاق‌های عمومی",
      fields: {
        world_readable: "کاربران مهمان می‌توانند بدون عضویت، محتوا را مشاهده کنند",
        guest_can_join: "کاربران مهمان می‌توانند عضو شوند",
      },
      action: {
        title:
          "حذف اتاق از فهرست |||| حذف %{smart_count} اتاق از فهرست",
        content:
          "Are you sure you want to remove this room from directory? |||| Are you sure you want to remove these %{smart_count} rooms from directory",
        erase: "حذف از فهرست اتاق‌ها",
        create: "انتشار در فهرست اتاق‌ها",
        send_success: "اتاق با موفقیت منتشر شد",
        send_failure: "خطایی رخ داد.",
      },
    },
  },
};
export default fa;
